export const LOCAL_STORAGE = {
  theme: 'theme',
  newWellForm: 'new-well-form',
  draftDirectoryData: 'draftDirectoryData',
  draftTableData: 'draftTableData',
  lastDirectoryType: 'lastDirectoryType',
};
